<template>
  <div class="footer">
    <i class="logo"></i>
    <div class="right">
      <p class="link">
        <a
          class="btn"
          target="_blank"
          :href="`//gpassport.37games.com/center/JpServicePrivicy/service?gameId=${gameId}&language=ja`"
        >利用规约</a>
        <a
          class="btn"
          target="_blank"
          :href="`//gpassport.37games.com/center/JpServicePrivicy/privicy?gameId=${gameId}&language=ja`"
        >プライバシーポリシー</a>
        <a
          class="btn"
          target="_blank"
          :href="`//gpassport.37games.com/center/JpServicePrivicy/customize?keyWord=${shangqu}&gameId=${gameId}&language=ja`"
        >特定商取引法に基づく表示</a>
        <a
          class="btn"
          target="_blank"
          :href="`//gpassport.37games.com/center/JpServicePrivicy/customize?keyWord=${zijin}&gameId=${gameId}&language=ja`"
        >資金決済法に基づく表示</a>
      </p>
      <p class="copyright">© {{time}} 37GAMES, Ltd. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      time: new Date().getFullYear(),
      shangqu: window.pageInfo.shangqu,
      zijin: window.pageInfo.zijin,
    };
  },
  computed: {
    ...mapGetters(["gameId"]),
  },
};
</script>

<style lang="scss" scoped>
$left: 60vh;
.logo {
  background: url("../assets/image/logo.png") no-repeat center center;
  background-size: contain;
  height: 35vh;
  width: 202vh;
  position: absolute;
  left: $left;
  top: 50%;
  margin-top: -17.5vh;
}

.copyright {
  margin: 10vh auto 0;
  font-size: 14px;
}
.right {
  padding: $left 0;
  text-align: right;
}
.footer {
  width: 100%;
  box-sizing: border-box;
  background: white;
  padding: 0 $left;
  position: relative;
}
.link {
  margin: 0;
  font-size: 14vh;
}
.btn {
  color: #333;
  text-decoration: none;
  position: relative;
  margin-left: 20vh;
  font-size: 14vh;
  -webkit-text-size-adjust: none;
  &::before {
    content: "";
    position: absolute;
    width: 1px;
    font-size: 14vh;
    height: 14vh;
    background: black;
    top: 0;
    left: -10vh;
  }
  &:first-child {
    &::before {
      display: none;
    }
  }
}
#mobile .footer {
  padding: 0 10vh;

  .right {
    text-align: center;
    padding-top: 100vh;
  }
  .logo {
    left: 50%;
    top: 80vh;
    transform: translate(-50%, -50%);
  }
}
</style>